export const mmIconConstants = {
    translationGroup: "_icon"

}